import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { BrowserRouter } from 'react-router-dom';
import Keycloak from 'keycloak-js';
import { Provider } from 'react-redux';
import store from './reduxFiles/store';
import Full from './containers/Full/';
import { IntlConsumer, IntlProvider } from './IntlContext';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


let userOrdinal = window.sessionStorage.getItem('u');
userOrdinal = userOrdinal || window.localStorage.getItem('lastSelectedU');

axios.defaults.baseURL = process.env.REACT_APP_EUNSA_BACKEND_URL + '/u/' + (userOrdinal || 0);

axios.interceptors.request.use(config => {
    config.headers = {
        ...config.headers,
        ...{
            'Content-Type': 'application/json',
            Accept: 'application/json',
            // eslint-disable-next-line no-use-before-define
            Authorization: 'BEARER ' + kc.token
        }
    };
    return config;
});
const kc = Keycloak(process.env.REACT_APP_EUNSA_KEYCLOAK_JSON_URL);
kc.init({
    onLoad: 'check-sso',
    checkLoginIframe: process.env.NODE_ENV !== 'development'
}).success(authenticated => {
    if (authenticated) {
	    setInterval(() => {
            kc.updateToken(10).error(() => kc.logout());
        }, 10000);
        ReactDOM.render(
            <Provider store={store}>
                <IntlProvider>
                    <BrowserRouter>
                        <IntlConsumer>
                            {({ switchToEnglish, switchToBosnian, switchToCroatian }) => (
                                <Full switchToCroatian={switchToCroatian} switchToBosnian={switchToBosnian} />
                            )}
                        </IntlConsumer>
                    </BrowserRouter>
                </IntlProvider>
            </Provider>
            , document.getElementById('root')
        );
        // registerServiceWorker();
    } else {
        // show possibly other page here...
        kc.login();
    }
});



// WEBPACK FOOTER //
// ./src/index.js